/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {completeCopyModal} from '../common/util/complete-copy-modal';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {createResourceCopy} from '../../components/util/create-resource-copy';
import {nextCopyTitle} from '../../components/util/next-copy-title';
import {Uuid} from '../../components/util/uuid';
import {ReportScheduleResource} from '../../components/api/resources/resource/report-schedule.resource';

export interface ReportScheduleCopyResult {
  model: any;
  destination: boolean;
}

@Component({
  standalone: false,
  selector: 'adn-report-schedule-copy-modal',
  template: `
    <form class="form-horizontal" (ngSubmit)="copy()">
      <div class="modal-header dialogAddStuff">
        <button type="button" class="close" (click)="dismiss()">&times;</button>
        <h4 class="modal-title">
          <span>{{ 'label.copy.reportSchedule' | ogTranslate }}</span>
          <small>{{ originalName }}</small>
        </h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label class="col-md-3 control-label">{{ 'label.name' | ogTranslate }}</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="reportSchedule.name" [(ngModel)]="name" required>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-3 control-label">{{ 'label.description' | ogTranslate }}</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="reportSchedule.description" [(ngModel)]="description">
          </div>
        </div>
        <div class="checkbox text-right">
          <label class="checkbox">
            <input type="checkbox" [(ngModel)]="destination" name="reportSchedule.destination">
            <span class="small">Go to new report schedule after copy</span>
          </label>
        </div>
      </div>
      <div class="modal-footer">
        <a class="btn btn-link btn-xs" (click)="dismiss()">{{ 'button.cancel' | ogTranslate }}</a>
        <button type="submit" class="btn btn-default">{{ 'label.copy' | ogTranslate }}</button>
      </div>
    </form>
  `
})
export class ReportScheduleCopyModalComponent implements OnInit {
  model: any;

  readonly onCopied = new Subject<ReportScheduleCopyResult>();

  originalName = '';
  name = '';
  description = '';
  destination = true;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(ReportScheduleResource) private readonly ReportSchedule: any
  ) {
  }

  ngOnInit(): void {
    this.originalName = this.model?.name || '';
    this.name = nextCopyTitle(this.model?.name || '');
    this.description = this.model?.description || '';
  }

  copy(): void {
    const copy = createResourceCopy(this.ReportSchedule, this.model, {
      id: Uuid.generate(),
      name: this.name,
      description: this.description
    });
    copy.$save().then((saved: any) => {
      completeCopyModal(this.bsModalRef, this.onCopied, {model: saved, destination: this.destination});
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
